import { render, staticRenderFns } from "./PreOrderDetails.vue?vue&type=template&id=2b2caffc&"
import script from "./PreOrderDetails.vue?vue&type=script&lang=js&"
export * from "./PreOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports